import {
  Typography,
  Box,
  styled,
  TextField,
  Button,
  FormHelperText,
  Backdrop,
  CircularProgress,
  MenuItem,
} from "@mui/material";
import React, { useState, useEffect, useRef, useMemo } from "react";
import { useSelector } from "react-redux";
import User_D from "../../../assets/customerAssets/user_D.jpeg";
import CameraIcon from "../../../assets/customerAssets/icons/camera.svg";
import { useFormik } from "formik";
import * as Yup from "yup";
import { supportedImageFileTypes } from "../../../helper/commonFunctions";
import { toast } from "react-toastify";
import { editUser } from "../../../api/editUser";
import { useDispatch } from "react-redux";
import { countryCodes } from "../../../helper/commonFunctions";
import { getUser } from "../../../action/authActions";
import { useOnlyFirstRender } from "../../../hooks/useOnlyFirstRender";

const CustomTextarea = styled(TextField)(({ theme }) => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#191B2F",
    border: "1px solid #414466",
    borderRadius: "8px",
    color: "white",
    "&:hover": {
      backgroundColor: "#191B2F",
      border: "1px solid #414466",
    },
    "&.Mui-focused": {
      backgroundColor: "#191B2F",
      border: "1px solid #414466",
      outline: "none",
    },

    "& .MuiInputBase-input": {
      // maxHeight: "70px",
      [theme.breakpoints.down("md")]: {
        padding: "9.5px 7px",
      },
    },
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    "&:hover": {
      border: "none",
    },
  },
}));

const EditProfile = () => {
  const userData = useSelector((state) => state.user);
  const [previewImg, setPreviewImg] = useState(null);
  const profileInputRef = useRef(null);
  const editFormRef = useRef(null);
  const token = useSelector((state) => state.auth.token);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const countryCodeMemo = useMemo(() => {
    const cCode = userData.data?.phone_number?.slice(0, -10);
    let matchedCountryCode;
    countryCodes.map((value) => {
      const vCode = value.split(" ")[0];
      if (vCode == cCode) {
        matchedCountryCode = value;
      }
    });
    return matchedCountryCode;
  }, [userData, countryCodes]);

  const [countryCode, setCountryCode] = useState(
    () => countryCodeMemo || countryCodes[2]
  );

  /// ONLY FOR FIRST RENDER HOOK
  useOnlyFirstRender(() => {
    if (!userData.data.phone_number) {
      toast.info("Please add you phone number");
    }
  }, [userData]);

  const inititialValues = {
    profile_img: userData.data.profile_img || "",
    firstName: userData.data.firstName,
    lastName: userData.data.lastName,
    email: userData.data.email,
    phone_number: userData.data?.phone_number?.slice(-10) || "",
  };

  const validationSchema = Yup.object({
    profile_img: Yup.mixed(),
    firstName: Yup.string().required("First Name is required field"),
    lastName: Yup.string().required("Last Name is required field"),
    email: Yup.string()
      .email("Please enter valid email")
      .required("Email is requied"),
    phone_number: Yup.number("Must be a number")
      .required("Phone Number is required")
      .test(
        "phone_number_check",
        "Please enter valid mobile number",
        (value) => {
          return value.toString().length == 10 ? true : false;
        }
      ),
  });

  const formik = useFormik({
    initialValues: inititialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      values.user_id = userData.data.id;
      try {
        setLoading(true);
        const formvalues = {
          ...values,
          phone_number: countryCode.split(" ")[0] + values.phone_number,
        };
        const data = await editUser(formvalues, token);

        if (data.success) {
          toast.success("Profile updated successfully.");
          // dispatch({ type: "UPDATE_USER", payload: data.data });
          // dispatch({type : ""})
          dispatch(getUser(token, data?.data?.id));
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }

      // on success call this
    },
  });

  const handleProfileChange = (e) => {
    const file = e.target.files[0];
    // "";
    // "";

    if (file) {
      const fileType = file.type.split("/")[1];
      const fileExt = file.name.split(".").pop().toLowerCase();
      //   "";
      //   "";
      if (
        !supportedImageFileTypes.includes(fileType) &&
        !supportedImageFileTypes.includes(fileExt)
      ) {
        // "";
        formik.setFieldValue("profile_img", null);
        formik.setFieldError("profile_img", "File type not supported");
        toast.error("File type not supported");
        return;
      }
      setPreviewImg(URL.createObjectURL(file));
      formik.setFieldValue("profile_img", file);
    } else {
      setPreviewImg(null);
      formik.setFieldValue("profile_img", null);
      //   "";
    }
  };

  // "";

  return (
    <>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
        // onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box className="heading">
        <Typography component="h1">EDIT PROFILE</Typography>
      </Box>
      <Box className="form-wrapper">
        <form
          className="edit-profile-form"
          onSubmit={formik.handleSubmit}
          ref={editFormRef}
        >
          <Box className="profile-pic">
            <Box className="img-div">
              <input
                style={{ display: "none" }}
                type="file"
                name="profile_img"
                // value={formik.values.profile_img}
                ref={profileInputRef}
                onChange={handleProfileChange}
              />
              <img
                className="img-fluid custom"
                src={previewImg || userData.data.profile_img || User_D}
                alt="profile-img"
              />
              <Button
                className="camera-icon"
                onClick={() => {
                  if (profileInputRef) {
                    profileInputRef.current.click();
                  }
                }}
              >
                <img src={CameraIcon} className="img_fluid" />
              </Button>
            </Box>
          </Box>
          <Box className="form-field">
            {/* first name  */}
            <Box className="form-control">
              <Typography className="label">First Name</Typography>
              <CustomTextarea
                id="outlined-multiline-static"
                placeholder="Enter Your First Name"
                variant="outlined"
                value={formik.values.firstName}
                onChange={formik.handleChange}
                name="firstName"
              />

              {formik.touched.firstName && formik.errors.firstName ? (
                <FormHelperText sx={{ color: "red" }}>
                  {formik.errors.firstName}
                </FormHelperText>
              ) : (
                ""
              )}
            </Box>

            {/* lastname  */}
            <Box className="form-control">
              <Typography className="label">Last Name</Typography>
              <CustomTextarea
                id="outlined-multiline-static"
                placeholder="Enter Your Last Name"
                variant="outlined"
                value={formik.values.lastName}
                onChange={formik.handleChange}
                name="lastName"
              />

              {formik.touched.lastName && formik.errors.lastName ? (
                <FormHelperText sx={{ color: "red" }}>
                  {formik.errors.lastName}
                </FormHelperText>
              ) : (
                ""
              )}
            </Box>

            {/* email  */}
            <Box className="form-control">
              <Typography className="label">Email</Typography>
              <CustomTextarea
                id="outlined-multiline-static"
                placeholder="Enter Your Email"
                variant="outlined"
                value={formik.values.email}
                onChange={formik.handleChange}
                name="email"
              />

              {formik.touched.email && formik.errors.email ? (
                <FormHelperText sx={{ color: "red" }}>
                  {formik.errors.email}
                </FormHelperText>
              ) : (
                ""
              )}
            </Box>

            {/* mobile number  */}
            <Box className="form-control">
              <Typography className="label">Mobile Number</Typography>
              {/* <CustomTextarea
                id="outlined-multiline-static"
                placeholder="Enter Your Mobile Number"
                variant="outlined"
                value={formik.values.phone_number}
                onChange={formik.handleChange}
                name="phone_number"
                sx={{ flexGrow: "1" }}
              />
              {formik.touched.phone_number && formik.errors.phone_number ? (
                <FormHelperText sx={{ color: "red" }}>
                  {formik.errors.phone_number}
                </FormHelperText>
              ) : (
                ""
              )} */}

              <Box sx={{ display: "flex", gap: "15px" }}>
                <CustomTextarea
                  id="outlined-basic"
                  name="countryCode"
                  select
                  variant="outlined"
                  className="register_field"
                  placeholder="Email"
                  value={countryCode}
                  sx={{
                    color: "white",
                    width: "unset",
                    "& .MuiInputBase-input": {
                      color: "white",
                      maxWidth: "118px",
                    },
                    "& .MuiSelect-icon": {
                      color: "#838383 !important",
                    },

                    "& .MuiInputBase-input": {
                      paddingRight: {
                        // xs: "85px !important",
                      },
                      color: "white",
                    },

                    "& .MuiInputBase-root": {
                      // paddingRight: "5px",
                      "& .MuiSelect-select": {
                        width: "50px",
                      },
                    },
                  }}
                  onChange={(e) => setCountryCode(e.target.value)}
                  SelectProps={{
                    renderValue: (selected) => selected.split(" ").shift(),
                  }}
                >
                  {countryCodes.map((value) => (
                    <MenuItem value={value}>{value}</MenuItem>
                  ))}
                </CustomTextarea>
                <CustomTextarea
                  id="outlined-basic"
                  variant="outlined"
                  className="register_field"
                  placeholder="Mobile Number"
                  type="number"
                  value={formik.values.phone_number}
                  onChange={formik.handleChange}
                  name="phone_number"
                  sx={{
                    flexGrow: 1,
                    "& input[type=number]": {
                      MozAppearance: "textfield",
                    },
                    "& input[type=number]::-webkit-outer-spin-button": {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                    "& input[type=number]::-webkit-inner-spin-button": {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                  }}
                />
              </Box>
              {formik.touched.phone_number && formik.errors.phone_number ? (
                <FormHelperText sx={{ color: "red" }}>
                  {formik.errors.phone_number}
                </FormHelperText>
              ) : (
                ""
              )}
            </Box>

            <Button
              className="edit-profile-btn"
              //   onClick={() => {
              //     if (editFormRef.current) {
              //       editFormRef.current.submit();
              //     }
              //   }}
              type="submit"
            >
              Save
            </Button>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default EditProfile;
